import useClientContext from "../context/useClientContext";

export interface InvestorRelationsAccess {
  hasAccessToFundStructure: boolean;
  hasAccessToInvestorEmails: boolean;
  hasAccessToInvestorPortalSettings: boolean;
  hasAccessToInvestorRequests: boolean;
  hasAccessToDocumentCollections: boolean;
  hasAccessToDocumentActivity: boolean;
  hasAccessToFundraising: boolean;
  hasAccessToInvestorCommunications: boolean;
  hasAccessToInvestorRelations: boolean;
}

const useInvestorRelationsAccess = (): InvestorRelationsAccess => {
  const { hasAnyPermission, investorPortalApp, fundraisingApp, isPortalFeatureEnabled } = useClientContext();

  const hasAccessToFundStructure = hasAnyPermission(["ViewFundStructure", "ManageFundStructure"]);

  const hasAccessToInvestorEmails = hasAnyPermission(["ViewInvestorEmailDeliveryLog"]);

  const hasAccessToInvestorPortalSettings = hasAnyPermission([
    "ViewInvestorPortalSettings",
    "ManageInvestorPortalSettings",
  ]);

  const hasAccessToInvestorRequests = hasAnyPermission(["ViewInvestorRequests"]);

  const hasAccessToDocumentCollections = hasAnyPermission(["ViewDocumentCollections", "ManageDocumentCollections"]);

  const hasAccessToDocumentActivity =
    hasAccessToFundStructure && hasAnyPermission(["ViewInvestorPortalDocumentViewsAnalytics"]);

  const hasAccessToFundraising =
    hasAccessToInvestorPortalSettings &&
    hasAnyPermission(["ViewFundraisings", "ManageFundraisings"]) &&
    !!fundraisingApp;

  const hasAccessToInvestorCommunications =
    hasAnyPermission(["ViewInvestorCommunications", "ManageInvestorCommunications"]) &&
    isPortalFeatureEnabled("InvestorPortalNewsEnabled") &&
    !!investorPortalApp;

  return {
    hasAccessToFundStructure,
    hasAccessToInvestorEmails,
    hasAccessToInvestorPortalSettings,
    hasAccessToInvestorRequests,
    hasAccessToDocumentCollections,
    hasAccessToDocumentActivity,
    hasAccessToFundraising,
    hasAccessToInvestorCommunications,
    hasAccessToInvestorRelations:
      hasAccessToFundStructure ||
      hasAccessToInvestorEmails ||
      hasAccessToFundraising ||
      hasAccessToDocumentCollections ||
      hasAccessToInvestorCommunications ||
      Boolean(investorPortalApp && (hasAccessToInvestorPortalSettings || hasAccessToInvestorRequests)),
  };
};

export default useInvestorRelationsAccess;
